/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ShipmentState } from "./ShipmentState";
import {
  ShipmentStateFromJSON,
  ShipmentStateFromJSONTyped,
  ShipmentStateToJSON,
  ShipmentStateToJSONTyped,
} from "./ShipmentState";
import type { CompanyTemperature } from "./CompanyTemperature";
import {
  CompanyTemperatureFromJSON,
  CompanyTemperatureFromJSONTyped,
  CompanyTemperatureToJSON,
  CompanyTemperatureToJSONTyped,
} from "./CompanyTemperature";
import type { ControlsLtlFreight } from "./ControlsLtlFreight";
import {
  ControlsLtlFreightFromJSON,
  ControlsLtlFreightFromJSONTyped,
  ControlsLtlFreightToJSON,
  ControlsLtlFreightToJSONTyped,
} from "./ControlsLtlFreight";
import type { MissingInvoiceComparisonDay } from "./MissingInvoiceComparisonDay";
import {
  MissingInvoiceComparisonDayFromJSON,
  MissingInvoiceComparisonDayFromJSONTyped,
  MissingInvoiceComparisonDayToJSON,
  MissingInvoiceComparisonDayToJSONTyped,
} from "./MissingInvoiceComparisonDay";

/**
 *
 * @export
 * @interface ShipmentsMissingInvoicesRow
 */
export interface ShipmentsMissingInvoicesRow {
  /**
   *
   * @type {string}
   * @memberof ShipmentsMissingInvoicesRow
   */
  carrierIdentifier: string;
  /**
   *
   * @type {number}
   * @memberof ShipmentsMissingInvoicesRow
   */
  carrierNumberOfDaysToConsiderOverdue: number;
  /**
   *
   * @type {MissingInvoiceComparisonDay}
   * @memberof ShipmentsMissingInvoicesRow
   */
  carrierComparisonDay: MissingInvoiceComparisonDay;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentsMissingInvoicesRow
   */
  carrierShouldEmailCarrierToRequestInvoice: boolean;
  /**
   *
   * @type {number}
   * @memberof ShipmentsMissingInvoicesRow
   */
  quotedPriceByCarrierCad: number;
  /**
   *
   * @type {string}
   * @memberof ShipmentsMissingInvoicesRow
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentsMissingInvoicesRow
   */
  proNumber?: string | null;
  /**
   *
   * @type {ShipmentState}
   * @memberof ShipmentsMissingInvoicesRow
   */
  shipmentState: ShipmentState;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentsMissingInvoicesRow
   */
  bookedAt: OffsetDateTime;
  /**
   *
   * @type {LocalDate}
   * @memberof ShipmentsMissingInvoicesRow
   */
  actualDeliveryDate?: LocalDate | null;
  /**
   *
   * @type {string}
   * @memberof ShipmentsMissingInvoicesRow
   */
  missingInvoiceFrontConversationId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShipmentsMissingInvoicesRow
   */
  companyName: string;
  /**
   *
   * @type {CompanyTemperature}
   * @memberof ShipmentsMissingInvoicesRow
   */
  temperature?: CompanyTemperature | null;
  /**
   *
   * @type {ControlsLtlFreight}
   * @memberof ShipmentsMissingInvoicesRow
   */
  controlsLtlFreight: ControlsLtlFreight;
  /**
   *
   * @type {string}
   * @memberof ShipmentsMissingInvoicesRow
   */
  shipmentFrequency: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentsMissingInvoicesRow
   */
  shipmentFrequencyNote?: string | null;
  /**
   *
   * @type {number}
   * @memberof ShipmentsMissingInvoicesRow
   */
  daysOverdue?: number | null;
  /**
   *
   * @type {LocalDate}
   * @memberof ShipmentsMissingInvoicesRow
   */
  expectedInvoiceDate?: LocalDate | null;
}

/**
 * Check if a given object implements the ShipmentsMissingInvoicesRow interface.
 */
export function instanceOfShipmentsMissingInvoicesRow(
  value: object,
): value is ShipmentsMissingInvoicesRow {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("carrierNumberOfDaysToConsiderOverdue" in value) ||
    value["carrierNumberOfDaysToConsiderOverdue"] === undefined
  )
    return false;
  if (
    !("carrierComparisonDay" in value) ||
    value["carrierComparisonDay"] === undefined
  )
    return false;
  if (
    !("carrierShouldEmailCarrierToRequestInvoice" in value) ||
    value["carrierShouldEmailCarrierToRequestInvoice"] === undefined
  )
    return false;
  if (
    !("quotedPriceByCarrierCad" in value) ||
    value["quotedPriceByCarrierCad"] === undefined
  )
    return false;
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("shipmentState" in value) || value["shipmentState"] === undefined)
    return false;
  if (!("bookedAt" in value) || value["bookedAt"] === undefined) return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  if (
    !("controlsLtlFreight" in value) ||
    value["controlsLtlFreight"] === undefined
  )
    return false;
  if (
    !("shipmentFrequency" in value) ||
    value["shipmentFrequency"] === undefined
  )
    return false;
  return true;
}

export function ShipmentsMissingInvoicesRowFromJSON(
  json: any,
): ShipmentsMissingInvoicesRow {
  return ShipmentsMissingInvoicesRowFromJSONTyped(json, false);
}

export function ShipmentsMissingInvoicesRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentsMissingInvoicesRow {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    carrierNumberOfDaysToConsiderOverdue:
      json["carrierNumberOfDaysToConsiderOverdue"],
    carrierComparisonDay: MissingInvoiceComparisonDayFromJSON(
      json["carrierComparisonDay"],
    ),
    carrierShouldEmailCarrierToRequestInvoice:
      json["carrierShouldEmailCarrierToRequestInvoice"],
    quotedPriceByCarrierCad: json["quotedPriceByCarrierCad"],
    shipmentId: json["shipmentId"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    shipmentState: ShipmentStateFromJSON(json["shipmentState"]),
    bookedAt: json["bookedAt"],
    actualDeliveryDate:
      json["actualDeliveryDate"] == null
        ? undefined
        : json["actualDeliveryDate"],
    missingInvoiceFrontConversationId:
      json["missingInvoiceFrontConversationId"] == null
        ? undefined
        : json["missingInvoiceFrontConversationId"],
    companyName: json["companyName"],
    temperature:
      json["temperature"] == null
        ? undefined
        : CompanyTemperatureFromJSON(json["temperature"]),
    controlsLtlFreight: ControlsLtlFreightFromJSON(json["controlsLtlFreight"]),
    shipmentFrequency: json["shipmentFrequency"],
    shipmentFrequencyNote:
      json["shipmentFrequencyNote"] == null
        ? undefined
        : json["shipmentFrequencyNote"],
    daysOverdue: json["daysOverdue"] == null ? undefined : json["daysOverdue"],
    expectedInvoiceDate:
      json["expectedInvoiceDate"] == null
        ? undefined
        : json["expectedInvoiceDate"],
  };
}

export function ShipmentsMissingInvoicesRowToJSON(
  json: any,
): ShipmentsMissingInvoicesRow {
  return ShipmentsMissingInvoicesRowToJSONTyped(json, false);
}

export function ShipmentsMissingInvoicesRowToJSONTyped(
  value?: ShipmentsMissingInvoicesRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    carrierNumberOfDaysToConsiderOverdue:
      value["carrierNumberOfDaysToConsiderOverdue"],
    carrierComparisonDay: MissingInvoiceComparisonDayToJSON(
      value["carrierComparisonDay"],
    ),
    carrierShouldEmailCarrierToRequestInvoice:
      value["carrierShouldEmailCarrierToRequestInvoice"],
    quotedPriceByCarrierCad: value["quotedPriceByCarrierCad"],
    shipmentId: value["shipmentId"],
    proNumber: value["proNumber"],
    shipmentState: ShipmentStateToJSON(value["shipmentState"]),
    bookedAt: value["bookedAt"],
    actualDeliveryDate: value["actualDeliveryDate"],
    missingInvoiceFrontConversationId:
      value["missingInvoiceFrontConversationId"],
    companyName: value["companyName"],
    temperature: CompanyTemperatureToJSON(value["temperature"]),
    controlsLtlFreight: ControlsLtlFreightToJSON(value["controlsLtlFreight"]),
    shipmentFrequency: value["shipmentFrequency"],
    shipmentFrequencyNote: value["shipmentFrequencyNote"],
    daysOverdue: value["daysOverdue"],
    expectedInvoiceDate: value["expectedInvoiceDate"],
  };
}
